import { TipiArticoli } from './tipi-articoli';

export class Articoli {
  id: number = 0;
  codice: string = '';
  descrizione: string = '';
  taglia: string = '';
  giacenza: number = 0;
  totCarichi: number = 0;
  totScarichi: number = 0;
  idTipo: number = 0;
  scadenza: number = 0;
  idCategoria: number = 0;
  identificativo: string = '';
  note: string = '';
  scortaMinima: number = 0;
  attivo: boolean = false;
  tipo: TipiArticoli = new TipiArticoli();

  scortaMassima: number = 0;
  giorniLeadTime: number = 0;
  qtaLottoRiordino: number = 0;

  gestioneKit: boolean = false;
  idMatricola?: number;
  matricola?: string; //Serve per la dashboard della consegna/restituzione guidata
  quantita?: number;
  quantitaRestituita: number = 0; //Serve per la pagina di restituzione guidata
  idDipendente?: number; //Serve per la dashboard della consegna/restituzione guidata
  chiaveCustom?:string; //Serve per la restituzione Guidata
  componenteFiglio?: boolean = false; //Serve per la restituzione guidata
  dataInserimento?: Date; //Serve per la restituzione Guidata

}

export class ArticoliReqModel {
  idDipendente: number = 0;
  dataMovimento: Date = new Date();
}
